import vehicles from "../../../../services/vehicles.js";
import constantes from "../../../../pages/common/constantes"
import { constant } from "lodash";

export default {
    props: [
        'step',
        'ArrayVehicles',
        'formVisibility'
    ],

    data (){
        return {
            isClick: false,
            vehicles: constantes.VehiclesToSaveAdhesion,
            addVehicles: false,
            stepForm: 0,
            showModalInvalidPlate: false,
            loading: false,
            brandId: '',
            brand: '',
            models: [],
            errorStatus: false,
            msgError: "",
            modalConfirmVisibility: false
        }
    },
    methods: {
          stepBackZero() {
            return this.stepForm = 0;
          },
          stepNext() {
            return this.stepForm += 1;
          },
          rmvLoading() {
            return this.loading = false;
          },
          showLoading() {
            return this.loading = true;
          },
          rmvButton() {
            return this.addVehicles = false;
          },
          resetForm() {
            return this.addVehicles = false;
          },
          forceUptd() {
            return this.$forceUpdate();
          },
          rmvPlate() {
            let index = this.ArrayVehicles.findIndex(element => element.plate.toUpperCase() == this.plate.toUpperCase());
            this.ArrayVehicles.splice(index, 1);
            this.modalConfirmVisibility = false;
            if (this.ArrayVehicles.length == 0) {
              return this.$emit('stepBack')
            }
            return this.forceUptd();
          },
          removePlate(plate, modelName, brandName) {
            this.plate = plate;
            this.modelName = modelName;
            this.brandName = brandName;
            this.modalConfirmVisibility = true;
            return;
          },
          RemoveModal() {
            return this.modalConfirmVisibility = false;
          },
          PlateFormat(plate) {
            let result  = plate;
            let placa   = plate.replaceAll("-","");

            if(/^[A-Za-z]+$/.test(plate[5])) result = placa;

            return result;
          }
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Adhesion/form-add-vehicles/form-add-vehicles.js